import { createCrudSagas } from './CrudSagas'
import { EntityClassesActions } from '../reducers/EntityClassesRedux'

const crudSagas = createCrudSagas('entityClasses', EntityClassesActions)

export const findEntityClasses = crudSagas.findEntityClasses
export const getEntityClass = crudSagas.getEntityClass
export const updateEntityClass = crudSagas.updateEntityClass
export const watchEntityClasses = crudSagas.watchEntityClasses
export const unwatchEntityClasses = crudSagas.unwatchEntityClasses
export const createEntityClass = crudSagas.createEntityClass
export const deleteEntityClass = crudSagas.deleteEntityClass
